import { render, staticRenderFns } from "./SectionsConfig.vue?vue&type=template&id=7e9b145e&scoped=true"
import script from "./SectionsConfig.vue?vue&type=script&lang=js"
export * from "./SectionsConfig.vue?vue&type=script&lang=js"
import style0 from "./SectionsConfig.vue?vue&type=style&index=0&id=7e9b145e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9b145e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e9b145e')) {
      api.createRecord('7e9b145e', component.options)
    } else {
      api.reload('7e9b145e', component.options)
    }
    module.hot.accept("./SectionsConfig.vue?vue&type=template&id=7e9b145e&scoped=true", function () {
      api.rerender('7e9b145e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/questionConfig/subViews/detail/components/SectionsConfig.vue"
export default component.exports